import styled from "@emotion/styled";
import { alpha } from "@mui/material";

export const StyledContainer = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2, 2, 2, 0),
    gap: theme.spacing(2),
    overflow: "hidden", // prevent content from overflowing
}));

export const ThumbnailContainer = styled("div")(({ theme }) => ({
    position: "relative",
    width: 85,
    borderRadius: theme.kaltura.shape.roundness1,
    overflow: "hidden",
}));

export const Thumbnail = styled("div")(({ theme }) => ({
    width: "100%",
    paddingBottom: "56.25%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: theme.kaltura.palette.tone6,
}));

export const Duration = styled("div")(({ theme }) => ({
    position: "absolute",
    width: "100%",
    bottom: 0,
    padding: theme.spacing(0.5),
    background: `linear-gradient(168deg, ${alpha(theme.palette.common.black, 0)} 13.88%, ${alpha(theme.palette.common.black, 0.5)} 74.62%)`,
    color: theme.kaltura.palette.translucent.commonWhite,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
}));

export const ContentSection = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0, // prevents flex items from overflowing
}));

export const TitleContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    minWidth: 0, // prevent flex container from expanding beyond parent
}));

export const MediaInfo = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    minWidth: 0,
    color: theme.kaltura.palette.tone2,
}));

export const Separator = styled("span")(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
}));
